module.exports = __webpack_public_path__ + "static/media/faixa-marrom.f43c54fb.png";